import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeliveryMethodList = ({ deliveryMethods }) => {
  return (
    <Styles.MainContainer>
      {deliveryMethods?.map(deliveryMethod => (
        <Styles.DeliveryMethodContainer key={deliveryMethod.id}>
          <Text type="bodyMRegular">{deliveryMethod.internal_name}</Text>
        </Styles.DeliveryMethodContainer>
      ))}
    </Styles.MainContainer>
  )
}

export default DeliveryMethodList
